// ============================================
// ✅ CORRECCIÓN EN precioCalculator.mjs
// CON SOPORTE PARA MONEDAS MIXTAS
// ============================================

export const calcularPrecioFinal = (paquete, adultos = 1) => {
  if (!paquete) {
    return {
      precioBase: 0,
      descuentoTotalPorPersona: 0,
      descuentoTotal: 0,
      impuestos: 0,
      gastos: 0,
      total: 0,
      subtotalAdultos: 0,
      // ✅ NUEVO: Soporte para monedas mixtas
      tieneMonedasMixtas: false,
      tarifaAdicional: 0,
      monedaTarifaAdicional: 'U$S'
    };
  }

  // ✅ IMPORTANTE: La tarifa en BD YA tiene el descuento principal aplicado
  const precioBase = parseFloat(paquete.tarifa || 0);
  
    // Impuestos por persona
  const impuestosBase = parseFloat(paquete.impuestos || 0);
  
  // ✅ Gastos según la moneda del paquete
  const monedaPaquete = (paquete.moneda || '$').trim();
  const esMonedaDolares = monedaPaquete === 'U$S' || monedaPaquete === 'USD';
  const gastosBase = esMonedaDolares 
    ? parseFloat(paquete.gastos_dolares || 0)
    : parseFloat(paquete.gastos_pesos || 0);

  // ✅ NUEVO: Calcular precio ORIGINAL (antes del descuento principal)
  const descuentoPrincipalMonto = parseFloat(paquete.descuento_principal_monto || 0);
  const descuentoPrincipalTipo = (paquete.descuento_principal_tipo || 'fijo').toLowerCase();
  const tieneDescuentoPrincipal = descuentoPrincipalMonto > 0;
  
  let precioOriginal = precioBase; // Por defecto igual al precio base
  let montoDescuentoPrincipal = 0;
  
  if (tieneDescuentoPrincipal) {
    if (descuentoPrincipalTipo === 'porcentaje') {
      // Si es porcentaje: precioBase = precioOriginal * (1 - porcentaje/100)
      // Entonces: precioOriginal = precioBase / (1 - porcentaje/100)
      precioOriginal = precioBase / (1 - descuentoPrincipalMonto / 100);
      montoDescuentoPrincipal = precioOriginal - precioBase;
    } else {
      // Si es fijo: precioOriginal = precioBase + descuento
      precioOriginal = precioBase + descuentoPrincipalMonto;
      montoDescuentoPrincipal = descuentoPrincipalMonto;
    }
  }

  // ✅ NUEVO: Detectar monedas mixtas
  const tarifaAdicional = parseFloat(paquete.tarifa_adicional || 0);
  const monedaTarifaAdicional = (paquete.moneda_tarifa_adicional || 'U$S').trim();
  const paqMoneda = (paquete.moneda || '$').trim();
  
  const tieneMonedasMixtas = (paqMoneda === '$' || paqMoneda === 'ARS') && 
                             tarifaAdicional > 0 && 
                             (monedaTarifaAdicional === 'U$S' || monedaTarifaAdicional === 'USD');

  // ============================================
  // CÁLCULO PARA 1 ADULTO (lista de paquetes)
  // ============================================
  if (adultos === 1) {
    // ✅ CORRECCIÓN: NO sumar gastos al total (se muestran por separado en el detalle)
    const totalPesos = tieneMonedasMixtas 
      ? Math.round(precioBase + impuestosBase)  // Solo precio base + impuestos
      : Math.round(precioBase + impuestosBase + tarifaAdicional); // Sin gastos
    
    return {
      precioBase,
      subtotalAdultos: precioBase,
      descuentoTotalPorPersona: 0,
      descuentoTotal: 0,
      impuestos: impuestosBase,
      gastos: gastosBase,
      total: totalPesos,
      // ✅ NUEVO: Retornar datos de monedas mixtas
      tieneMonedasMixtas,
      tarifaAdicional: tieneMonedasMixtas ? tarifaAdicional : 0,
      monedaTarifaAdicional,
      // ✅ NUEVO: Datos del descuento principal para mostrar tachado
      tieneDescuentoPrincipal,
      precioOriginal: Math.round(precioOriginal + impuestosBase),
      montoDescuentoPrincipal: Math.round(montoDescuentoPrincipal),
      descuentoPrincipalTipo,
      descuentoPrincipalPorcentaje: descuentoPrincipalTipo === 'porcentaje' ? descuentoPrincipalMonto : 0
    };
}

  // ============================================
  // CÁLCULO PARA 2+ ADULTOS (detalle del paquete)
  // ============================================
  const subtotalAdultos = precioBase * adultos;
  let descuentoTotal = 0;

  // Descuento 2do pasajero (solo si hay 2+ adultos)
  if (adultos >= 2 && paquete.descuento_2do_pasajero_monto && parseFloat(paquete.descuento_2do_pasajero_monto) > 0) {
    if (paquete.descuento_2do_pasajero_tipo === 'porcentaje') {
      descuentoTotal += (precioBase * parseFloat(paquete.descuento_2do_pasajero_monto)) / 100;
    } else {
      descuentoTotal += parseFloat(paquete.descuento_2do_pasajero_monto);
    }
  }

  // Descuento 3er pasajero (solo UNA VEZ para el 3er pasajero)
  if (adultos >= 3 && paquete.descuento_3er_pasajero_monto && parseFloat(paquete.descuento_3er_pasajero_monto) > 0) {
    if (paquete.descuento_3er_pasajero_tipo === 'porcentaje') {
      descuentoTotal += (precioBase * parseFloat(paquete.descuento_3er_pasajero_monto)) / 100;
    } else {
      descuentoTotal += parseFloat(paquete.descuento_3er_pasajero_monto);
    }
  }

  // Impuestos y gastos totales
  const impuestosTotal = impuestosBase * adultos;
  const gastosTotal = gastosBase * adultos;

  // Total final
  const total = subtotalAdultos - descuentoTotal + impuestosTotal + gastosTotal;

  return {
    precioBase,
    subtotalAdultos,
    descuentoTotalPorPersona: 0,
    descuentoTotal: Math.round(descuentoTotal),
    impuestos: Math.round(impuestosTotal),
    gastos: Math.round(gastosTotal),
    total: Math.round(total),
    // ✅ Datos de monedas mixtas
    tieneMonedasMixtas,
    tarifaAdicional,
    monedaTarifaAdicional,
    tarifaAdicionalTotal: tarifaAdicional * adultos,
    // ✅ Datos del descuento principal para mostrar tachado
    // precioOriginal INCLUYE impuestos para ser comparable con el total
    tieneDescuentoPrincipal,
    precioOriginal: Math.round((precioOriginal * adultos) + impuestosTotal),
    montoDescuentoPrincipal: Math.round(montoDescuentoPrincipal * adultos),
    descuentoPrincipalTipo,
    descuentoPrincipalPorcentaje: descuentoPrincipalTipo === 'porcentaje' ? descuentoPrincipalMonto : 0
  };
};